// Transcript type (SubmitTranscriptDto.TranscriptType) → i18n label key. Shared by the
// transcript form and the source list badge.
export const transcriptTypeKeys = {
  interview: "transcript_interview",
  referenceCall: "transcript_reference",
  press: "transcript_press",
  informal: "transcript_informal",
};
